import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import _ from 'lodash';
import Links from './Links';
import { getHelmetData } from './BreadcrumbsHelper';
import {
  articleDetailParser,
  collectionParser,
  liveParser,
  foxLiveParser,
  seriesDetailParser,
  showsParser,
  watchParser,
} from './BreadcrumbsDataParsers';
import Style from './Breadcrumbs.module.scss';

export const breadcrumbsArticleDetailParser = articleDetailParser;
export const breadcrumbsCollectionParser = collectionParser;
export const breadcrumbsLiveParser = liveParser;
export const breadcrumbsFoxLiveParser = foxLiveParser;
export const breadcrumbsSeriesDetailParser = seriesDetailParser;
export const breadcrumbsShowsParser = showsParser;
export const breadcrumbsWatchParser = watchParser;

const Breadcrumbs = ({ data, theme = null, customStyle = null }) => {
  if (!data) return null;
  const filteredData = _.filter(data, value => !_.isEmpty(value));
  const helmetData = getHelmetData(filteredData);
  return (
    <div
      data-testid="breadcrumbs"
      className={classNames([Style.container, theme.container, customStyle])}
    >
      <Helmet>{helmetData}</Helmet>
      <Links data={filteredData} theme={theme} />
    </div>
  );
};

Breadcrumbs.defaultProps = {
  data: [],
  theme: {},
  customStyle: '',
};

Breadcrumbs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool])),
  theme: PropTypes.shape({}),
  customStyle: PropTypes.string,
};

export default Breadcrumbs;
